var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vgs-icon-set"},[_c(_vm.iconComponent,{tag:"component",staticClass:"inline-block fill-current",attrs:{"role":"img"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }